import ReportListSider from './container/index';

export default ReportListSider;



// WEBPACK FOOTER //
// ./src/views/ReportListSider/index.js